const tpl = (name) => `NOTIFICATIONS/${name}`;

export const INITIALIZE_NOTIFICATIONS = tpl`INITIALIZE_NOTIFICATIONS`;

export const SHOW_SIDEBAR = tpl`SHOW_SIDEBAR`;
export const HIDE_SIDEBAR = tpl`HIDE_SIDEBAR`;

export const NOTIFICATIONS_ON_LOGIN = tpl`NOTIFICATIONS_ON_LOGIN`;

export const NOTIFICATIONS = tpl`NOTIFICATIONS`;
export const NOTIFICATIONS_SUCCESS = tpl`NOTIFICATIONS_SUCCESS`;
export const NOTIFICATIONS_FAILURE = tpl`NOTIFICATIONS_FAILURE`;

export const LATEST_NOTIFICATIONS = tpl`LATEST_NOTIFICATIONS`;
export const LATEST_NOTIFICATIONS_SUCCESS = tpl`LATEST_NOTIFICATIONS_SUCCESS`;
export const LATEST_NOTIFICATIONS_FAILURE = tpl`LATEST_NOTIFICATIONS_FAILURE`;

export const START_NOTIFICATIONS_POLLING = tpl`START_NOTIFICATIONS_POLLING`;
export const STOP_NOTIFICATIONS_POLLING = tpl`STOP_NOTIFICATIONS_POLLING`;

export const NOTIFICATIONS_READ = tpl`NOTIFICATIONS_READ`;
export const NOTIFICATIONS_READ_SUCCESS = tpl`NOTIFICATIONS_READ_SUCCESS`;
export const NOTIFICATIONS_READ_FAILURE = tpl`NOTIFICATIONS_READ_FAILURE`;

export const NOTIFICATIONS_REMOVE = tpl`NOTIFICATIONS_REMOVE`;
export const NOTIFICATIONS_REMOVE_SUCCESS = tpl`NOTIFICATIONS_REMOVE_SUCCESS`;
export const NOTIFICATIONS_REMOVE_FAILURE = tpl`NOTIFICATIONS_REMOVE_FAILURE`;

export const NOTIFICATIONS_READ_ALL = tpl`NOTIFICATIONS_READ_ALL`;
export const NOTIFICATIONS_READ_ALL_SUCCESS = tpl`NOTIFICATIONS_READ_ALL_SUCCESS`;
export const NOTIFICATIONS_READ_ALL_FAILURE = tpl`NOTIFICATIONS_READ_ALL_FAILURE`;

export const NOTIFICATIONS_REMOVE_ALL = tpl`NOTIFICATIONS_REMOVE_ALL`;
export const NOTIFICATIONS_REMOVE_ALL_SUCCESS = tpl`NOTIFICATIONS_REMOVE_ALL_SUCCESS`;
export const NOTIFICATIONS_REMOVE_ALL_FAILURE = tpl`NOTIFICATIONS_REMOVE_ALL_FAILURE`;

export const NOTIFICATIONS_SET_WATCHED = tpl`NOTIFICATIONS_SET_WATCHED`;

export const NOTIFICATIONS_MORE = tpl`NOTIFICATIONS_MORE`;
export const NOTIFICATIONS_MORE_SUCCESS = tpl`NOTIFICATIONS_MORE_SUCCESS`;
export const NOTIFICATIONS_MORE_FAILURE = tpl`NOTIFICATIONS_MORE_FAILURE`;

export const SHOW_TOAST = tpl`SHOW_TOAST`;
export const DISMISS_TOAST = tpl`DISMISS_TOAST`;
export const DISMISS_GROUP = tpl`DISMISS_GROUP`;
export const QUEUE_TOAST = tpl`QUEUE_TOAST`;
export const CLEAR_TOASTS_QUEUE = tpl`CLEAR_TOASTS_QUEUE`;
export const SET_UNREAD_COUNTER = tpl`SET_UNREAD_COUNTER`;

export const SHOW_MODAL = tpl`SHOW_MODAL`;
export const CLOSE_MODAL = tpl`CLOSE_MODAL`;
